import styled from 'styled-components';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';

export const StyledAIOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  .container-mode {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`;

export const StyledRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
`;

export const StyledRowLabelGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

// Label + optional caption stacked in the left column of a row. `min-width: 0`
// lets a long caption wrap instead of pushing the dropdown out of alignment.
export const StyledRowLabelColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
`;

// Hover target inside the supported-languages caption. The dotted underline is
// the only cue that the collapsed count reveals the remaining names.
export const StyledMoreLanguages = styled.span`
  text-decoration: underline dotted;
  text-underline-offset: 2px;
  cursor: pointer;
`;

export const StyledRowRightGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StyledModelAnchor = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  height: 40px;
  width: ${({ $width }) => $width || '240px'};
  padding: 8px 12px;
  border-radius: 8px;
  border: 0.5px solid ${COLOR.indigo[16]};
  cursor: pointer;
  box-sizing: border-box;
`;

export const StyledPopoverList = styled.div`
  padding: 8px;
`;

export const StyledPopoverItem = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  background-color: ${({ $active }) =>
    $active ? COLOR.secondary[40] : 'transparent'};
`;

export const StyledPopoverItemText = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const StyledItalicTypography = styled(Typography)`
  font-style: italic !important;
`;

export const StyledTipBox = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 12px;
  padding: 12px;
  border-radius: 8px;
  background-color: ${COLOR.bluev2[8]};
  width: 100%;
  box-sizing: border-box;
`;

export const StyledTipText = styled(Typography)`
  flex: 1 0 0;
`;
